const initialState = {
  user: {},
  company: {},
  companyID: 0,
  uploadProgress: -1,
  uploadMessage: undefined,
  reportType: "summary",
  reportReload: true,
  campaigns: [],
  campaignsLoading: true,
  importsOpen: false,
  newUserOpen: false,
  newRoleOpen: false,
  campaignEditorObject: undefined,
  campaignEditorQuestions: [
    {
      element_id: "",
      attr_text: "",
      live: false,
      attr_trigger: "",
    },
  ],
  campaignEditorProviders: [],
  forceCampaignReload: false,
  forceCampaignReDownload: false,
  newProviderOpen: false,
};

const localState = JSON.parse(localStorage.getItem("cccStores"));

const saveCampaignData = (state, { value }) => ({
  ...state,
  campaigns: value,
  campaignsLoading: false,
});

const changeCampaign = (state, { value }) => ({
  ...state,
  campaigns: value,
  campaignsLoading: false,
  forceCampaignReload: true,
});

const toggleCampaignReload = (state, { value }) => ({
  ...state,
  forceCampaignReload: value,
});

const toggleCampaignRedownload = (state, { value }) => ({
  ...state,
  forceCampaignReDownload: value,
});

const toggleImportsOpen = (state, { value }) => ({
  ...state,
  importsOpen: value,
});

const setReportType = (state, { value }) => ({
  ...state,
  reportType: value,
  reportReload: true,
});

const stopReportReload = (state, {}) => ({
  ...state,
  reportReload: false,
});

const toggleNewUserOpen = (state, { value }) => ({
  ...state,
  newUserOpen: value,
});

const toggleNewRoleOpen = (state, { value }) => ({
  ...state,
  newRoleOpen: value,
});

const setUploadProgress = (state, { value }) => ({
  ...state,
  uploadProgress: value,
});

const setUploadMessage = (state, { value }) => ({
  ...state,
  uploadMessage: value,
});

const toggleNewProviderOpen = (state, { value }) => ({
  ...state,
  newProviderOpen: value,
});

const setCampaignEditorObject = (state, { value }) => ({
  ...state,
  campaignEditorQuestions:
    value != undefined && value.questions != undefined
      ? value.questions
      : [
          {
            element_id: "",
            attr_text: "",
            live: false,
            attr_trigger: "",
          },
        ],
  campaignEditorObject: value != undefined ? value.campaign : undefined,
  campaignEditorProviders:
    value != undefined && value.providers != undefined ? value.providers : [],
});

const setCampaignEditorQuestions = (state, { value }) => ({
  ...state,
  campaignEditorQuestions:
    value != undefined
      ? value
      : [
          {
            element_id: "",
            attr_text: "",
            live: false,
            attr_trigger: "",
          },
        ],
});

const removeCampaignData = (state, {}) => ({
  campaigns: [],
  campaignsLoading: false,
});

const saveUserData = (state, { value }) => ({
  ...state,
  user: value,
});

const removeUserData = (state, {}) => ({
  user: {},
});

const logout = (state, {}) => initialState;

const saveCompanyID = (state, { value }) => ({
  ...state,
  companyID: value,
});

const removeCompanyID = (state, {}) => ({
  companyID: 0,
});

const saveCompany = (state, { value }) => ({
  ...state,
  company: value,
});

const createReducer = (handlers) => (state, action) => {
  if (!handlers.hasOwnProperty(action.type)) {
    return state;
  }
  const data = handlers[action.type](state, action);
  localStorage.setItem("cccStores", JSON.stringify(data));
  return data;
};

const storesReducerHandler = {
  saveUserData,
  removeUserData,
  saveCampaignData,
  changeCampaign,
  removeCampaignData,
  saveCompanyID,
  removeCompanyID,
  toggleImportsOpen,
  toggleCampaignReload,
  setCampaignEditorObject,
  setCampaignEditorQuestions,
  toggleNewUserOpen,
  toggleNewRoleOpen,
  toggleNewProviderOpen,
  logout,
  setUploadProgress,
  setUploadMessage,
  setReportType,
  stopReportReload,
  toggleCampaignRedownload,
  saveCompany,
};

export const StoresReducer = [
  createReducer(storesReducerHandler),
  localState || initialState,
];
